import styled from 'styled-components';
import { Link } from '../Link';
var BlockLink = styled(Link).withConfig({
  displayName: "BlockLink",
  componentId: "ybjvrc-0"
})(["display:block;color:inherit;text-decoration:none;"]);
BlockLink.displayName = 'BlockLink';
BlockLink.propTypes = Link.propTypes;
export default BlockLink;